import React from 'react';
import { Box, Button, TextButton, Text } from '@wix/design-system';
import { StatusWarningFilledSmall } from '@wix/wix-ui-icons-common';
import { useFileUpload } from './useFileUpload';
import { UPLOAD_IMAGES_WIDGET } from '../consts';
import ImageUploader from './ImageUploader';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
export const UploadImagesWidget = _ref => {
  let {
    data: {
      label,
      subtitle,
      uploadButtonText,
      supportedFormats,
      errorsMessages,
      primaryButton,
      secondaryButton
    },
    context: {
      onWidgetAction,
      emitSideEffect
    },
    config
  } = _ref;
  const {
    isLoading,
    error,
    handleFileSelected,
    handleRemoveImage,
    images,
    files,
    clearErrors
  } = useFileUpload();
  const {
    areControlsDisabled
  } = useDisabledWidget(config);
  const handleWidgetAction = React.useCallback(actionData => {
    clearErrors();
    onWidgetAction == null || onWidgetAction(UPLOAD_IMAGES_WIDGET, {
      action: actionData.buttonName,
      value: actionData
    });
    emitSideEffect(actionData.sideEffectName, {
      images: actionData.uploadedImages,
      files: actionData.uploadedFiles
    });
  }, [onWidgetAction, emitSideEffect, clearErrors]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px",
    paddingTop: "SP1",
    paddingBottom: "SP1",
    minWidth: "590px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, label), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true,
    skin: areControlsDisabled ? 'disabled' : undefined
  }, subtitle), /*#__PURE__*/React.createElement(ImageUploader, {
    images: images,
    isLoading: isLoading,
    uploadButtonText: uploadButtonText,
    supportedFormats: supportedFormats,
    errorsMessages: errorsMessages,
    handleFileSelected: handleFileSelected,
    handleRemoveImage: handleRemoveImage,
    isCompleted: areControlsDisabled
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: "18px"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "18px"
  }, /*#__PURE__*/React.createElement(Button, {
    style: {
      width: '55px'
    },
    size: "tiny",
    disabled: images.length === 0 || areControlsDisabled,
    onClick: () => handleWidgetAction({
      buttonName: primaryButton.buttonName,
      sideEffectName: primaryButton.sideEffectName,
      uploadedImages: images,
      uploadedFiles: files
    })
  }, primaryButton.label), /*#__PURE__*/React.createElement(TextButton, {
    skin: "standard",
    size: "tiny",
    onClick: () => handleWidgetAction({
      buttonName: secondaryButton.buttonName,
      sideEffectName: secondaryButton.sideEffectName
    }),
    disabled: areControlsDisabled
  }, secondaryButton.label))), error && /*#__PURE__*/React.createElement(Box, {
    color: "Y10",
    gap: "3px"
  }, /*#__PURE__*/React.createElement(StatusWarningFilledSmall, null), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, error)));
};
//# sourceMappingURL=UploadImagesWidget.js.map